//@ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { registerSW } from "virtual:pwa-register";
import { cleanupOutdatedCaches } from "workbox-precaching";
import * as Sentry from "@sentry/react";
import { version } from "components/VersionNumber/VersionNumber";
import awsmobile from "aws-exports";
import { hasUnsavedWork } from "utils/connectionStatus";

export const feedback = Sentry.feedbackIntegration({
	colorScheme: "system",
	showBranding: false,
	isEmailRequired: true,
	messagePlaceholder: "What is the bug? How can we reproduce it?",
	captureScreenShots: true,
	autoInject: false,
});

const sentryIntegrations = [feedback, Sentry.browserTracingIntegration()];
let sampleRate = undefined;
let errorSampleRate = undefined;

if (import.meta.env.VITE_APP_ENV === "production") {
	sentryIntegrations.push(Sentry.replayIntegration());
	sampleRate = 0.1;
	errorSampleRate = 1.0;
}

Sentry.init({
	dsn: import.meta.env.VITE_APP_SENTRY_DSN,
	environment: import.meta.env.VITE_APP_ENV,
	integrations: sentryIntegrations,
	// Performance Monitoring
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: [awsmobile.aws_appsync_graphqlEndpoint],
	// Session Replay
	replaysSessionSampleRate: sampleRate, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: errorSampleRate, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	// Offline Monitoring
	transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
	beforeSend(event, hint) {
		if (event.exception && event.event_id && event.tags["modal"] === "true") {
			Sentry.showReportDialog({ eventId: event.event_id });
		}
		return event;
	},
	// Enable logs to be sent to Sentry
	_experiments: { enableLogs: true },
	maxValueLength: 1000000,
	normalizeDepth: 10,
});

Sentry.setTag("record-version", version);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
	// <React.StrictMode>
	<div id="rootiest-tootiest">
		<Sentry.ErrorBoundary>
			<App />
		</Sentry.ErrorBoundary>
	</div>,
	// </React.StrictMode>
);

/** How often to re-check for unsaved field writes before offering the version refresh. */
const REFRESH_PROMPT_RECHECK_MS = 15000;

const updateSW = registerSW({
	onNeedRefresh() {
		cleanupOutdatedCaches();
		// Accepting this prompt reloads the page, which discards any field value that has not been written yet. Wait until
		// nothing is pending or failed before asking. The prompt is a native confirm, so it also blurs the active field.
		const askWhenSafe = () => {
			if (hasUnsavedWork()) {
				setTimeout(askWhenSafe, REFRESH_PROMPT_RECHECK_MS);
				return;
			}
			const update = confirm("New version available! Refresh to update?");
			if (update) updateSW();
		};
		askWhenSafe();
	},
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
